import React from "react";

import DashboardLayout from "@/components/layout/DashboardLayout";
import { Button } from "@/components/ui/button";
import Typography from "@/components/ui/typography";
import AdminsTable from "@/features/admins/components/admin/AdminsTable";
import NewAdminDrawer from "@/features/admins/components/admin/NewAdminDrawer";

const Admins = () => {
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const [selectedAdminId, setSelectedAdminId] = React.useState<string | null>(
    null,
  );

  const onSetViewEditAdmin = (id: string) => {
    setSelectedAdminId(id);
    setOpenDrawer(true);
  };

  const onClearAdminSelection = () => {
    setSelectedAdminId(null);
    setOpenDrawer(false);
  };

  return (
    <DashboardLayout>
      <div className="space-y-6">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <Typography size="h1">Admins</Typography>
          <Button onClick={() => setOpenDrawer(true)}>New Admin</Button>
        </div>

        <AdminsTable setAdminId={onSetViewEditAdmin} />

        <NewAdminDrawer
          open={openDrawer}
          setOpen={setOpenDrawer}
          selectedAdminId={selectedAdminId}
          onClearAdminSelection={onClearAdminSelection}
        />
      </div>
    </DashboardLayout>
  );
};

export default Admins;
